import { render, staticRenderFns } from "./Confirmacao.vue?vue&type=template&id=7c2df188&"
import script from "./Confirmacao.vue?vue&type=script&lang=js&"
export * from "./Confirmacao.vue?vue&type=script&lang=js&"
import style0 from "./Confirmacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCheckbox,VOverlay,VProgressCircular})
